// Path: ./src/app/components/AccountCard/index.tsx
import { Grid } from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { ListTableQueryPagination } from "../ListTable/ListTableQueyPagination";
import { AccountCardWrapper } from "../AccountCardWrapper";
import { ListCard } from "../ListCard";
import {
  GridCallbackDetails,
  GridColDef,
  GridPaginationModel,
  GridRowSelectionModel,
  GridFilterModel,
  GridValidRowModel,
} from "@mui/x-data-grid";
import { GridSortModel } from "@mui/x-data-grid";
import { ColorButton, ListTableWrapper } from "./styled";
import { PermissionComponentWrapper } from "../PermissionComponentWrapper";

interface Props<T extends GridValidRowModel> {
  isLoading?: boolean;
  /** The last list fetch failed; the table warns that rows may be stale. */
  loadFailed?: boolean;
  cardTitle: string;
  buttonText?: string;
  buttonDataTestId?: string;

  permissionList?: {
    userName?: string;

    title: string;
    subTitle: string;
    bottomTitle: string;
    listItems?: {
      title: string;
      itemsList?: string[];
    }[];
  };
  rolesData?: {
    columns?: GridColDef[]; //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) this is not good since sharing type in both admin user and role
    rows?: T[];
    total?: number;
  };
  initialPaginationModel?: {
    page: number;
    pageSize: number;
  };
  initialSortModel?: GridSortModel;
  setPagination?: // eslint-disable-next-line
  | ((model: GridPaginationModel, details: GridCallbackDetails<any>) => void)
    | undefined;
  // eslint-disable-next-line
  handleRowSelect?: (value?: GridRowSelectionModel | undefined) => void;
  /**
   * Callback function triggered when the element is clicked.
   * Used for creating a role or a user.
   */
  onClick?: () => void;
  onRowClick?: () => void;
  setSortModel?: (model: GridSortModel, details: GridCallbackDetails) => void;
  onTableChange: (
    gridPaginationModel: GridPaginationModel,
    gridSortModel: GridSortModel
  ) => void;
  permissionRoleName: string;
  permissionGroupName: string;
  onFilterModelChange?: (filterModel: GridFilterModel) => void;
  filterModel?: GridFilterModel;
}
export const AccountCard = <T extends GridValidRowModel>({
  cardTitle,
  buttonText,
  permissionList,
  onClick,
  rolesData,
  initialPaginationModel,
  initialSortModel,
  handleRowSelect,
  onRowClick,
  buttonDataTestId,
  onTableChange,
  isLoading,
  loadFailed,
  permissionGroupName,
  permissionRoleName,
  onFilterModelChange,
  filterModel,
}: Props<T>) => {
  return (
    <AccountCardWrapper title={cardTitle} data-testid="accountcard-test-id">
      <Grid
        container
        spacing={2}
        style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 5 }}
      >
        {buttonText && (
          <Grid
            item
            xs={12}
            style={{
              justifyContent: "end",
              display: "flex",
              marginTop: 12,
            }}
          >
            <PermissionComponentWrapper
              requiredPermission={[permissionRoleName]}
              requiredPermissionGroup={[permissionGroupName]}
            >
              <ColorButton
                variant="contained"
                startIcon={<ControlPointIcon />}
                onClick={onClick}
                data-testid={buttonDataTestId}
              >
                {buttonText}
              </ColorButton>
            </PermissionComponentWrapper>
          </Grid>
        )}

        <Grid item xs={12} md={8}>
          <ListTableWrapper>
            <ListTableQueryPagination
              columns={rolesData?.columns}
              rows={rolesData?.rows}
              total={rolesData?.total}
              isLoading={isLoading}
              loadFailed={loadFailed}
              paginationModel={initialPaginationModel}
              sortModel={initialSortModel}
              handleRowSelection={(value) => {
                handleRowSelect && handleRowSelect(value);
              }}
              onRowClick={onRowClick}
              onTableChange={onTableChange}
              dynamicHeightAdjuster={295}
              filterModel={filterModel}
              onFilterModelChange={onFilterModelChange}
            />
          </ListTableWrapper>
        </Grid>
        {permissionList && (
          <Grid item xs={12} md={4}>
            <ListCard
              title={permissionList?.title}
              subTitle={permissionList?.subTitle}
              bottomTitle={permissionList?.bottomTitle}
              listItems={permissionList?.listItems}
              userName={permissionList?.userName}
            />
          </Grid>
        )}
      </Grid>
    </AccountCardWrapper>
  );
};
